import {createGeneralPageEventsAndComponents} from "../components/page-general";

window.addEventListener('DOMContentLoaded', () => {
	createGeneralPageEventsAndComponents();
});
